import { ManagedRuntime, Logger, Layer } from "effect";

const BaseRuntime = ManagedRuntime.make(
  Layer.empty.pipe(Layer.provide(Logger.pretty)),
);

addEventListener("beforeunload", () => {
  BaseRuntime.dispose();
});

export const extendRuntime = <R, E>(layer: Layer.Layer<R, E, never>) => {
  const runtime = ManagedRuntime.make(
    layer.pipe(Layer.provide(Logger.pretty)),
    BaseRuntime.memoMap,
  );

  addEventListener("beforeunload", () => {
    runtime.dispose();
  });

  return runtime;
};
